<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useSearchContext } from '../composables/searchContext';
import DisciplineFilter from './DisciplineFilter.vue';
import FacetGroup from './FacetGroup.vue';
import SeriesFacet from './SeriesFacet.vue';
const search = useSearchContext();
const groupedFacetIds = computed(() => new Set(search.primaryFacetGroups.value.flatMap((group) => group.facets.map((facet) => facet.AttributeTypeSk))));
const standardFacets = computed(() => search.productFacets.value.filter((facet) => !groupedFacetIds.value.has(facet.AttributeTypeSk)));
function divisionUrl(division: string): string {
  const query = encodeURIComponent(search.state.query.replaceAll(':', '158H'));
  return `/search/pg/1/sortOrder/r/div/${division}/qry/${query}`;
}
const divisions = computed(() => [
  { key: 'primary', label: 'Primary', count: search.divisionCounts.primary },
  { key: 'secondary', label: 'Secondary', count: search.divisionCounts.secondary },
  ...(search.config.isB2BUser ? [{ key: 'universityb2b', label: 'University', count: search.divisionCounts.university }, { key: 'vetb2b', label: 'VET', count: search.divisionCounts.vet }] : [])
]);
const divisionNavigation = ref<HTMLElement | null>(null);
const divisionIsFixed = ref(false);
const divisionLeft = ref('0px');
let divisionOffsetTop = 0;

function updateDivisionNavigation(): void {
  const navigation = divisionNavigation.value;
  if (!navigation || window.innerWidth <= 768) {
    divisionIsFixed.value = false;
    return;
  }

  if (!divisionIsFixed.value) {
    const bounds = navigation.getBoundingClientRect();
    divisionOffsetTop = bounds.top + window.scrollY;
    divisionLeft.value = `${bounds.left}px`;
  }

  divisionIsFixed.value = window.scrollY >= divisionOffsetTop - 50;
}

onMounted(() => {
  updateDivisionNavigation();
  window.addEventListener('scroll', updateDivisionNavigation, { passive: true });
  window.addEventListener('resize', updateDivisionNavigation);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateDivisionNavigation);
  window.removeEventListener('resize', updateDivisionNavigation);
});
</script>

<template>
  <div :class="{ 'mobile-panel-open': search.mobileFiltersVisible.value }">
    <nav v-if="search.state.division === 'all' || search.totalResults.value === 0" ref="divisionNavigation" id="left-division" class="left-division Alldivision-SearchDIv" :class="{ fixed: divisionIsFixed }" :style="{ '--left-division-left': divisionLeft }" aria-label="Narrow by division">
      <h3 class="left-divisiontitle">Narrow by division</h3>
      <ul class="Alldivision-SearchUl"><li v-for="division in divisions" :key="division.key" class="Alldivision-Searchli" :class="{ noproduct: division.count === 0 }"><a v-if="division.count > 0" class="alldiv-searchlink division-link" :href="divisionUrl(division.key)" @click.prevent="search.selectDivision(division.key)"><span>{{ division.label }} <span class="clr_blue">({{ division.count }})</span></span><span class="fa-solid fa-chevron-right division-chevron" aria-hidden="true"></span></a><span v-else class="alldiv-searchlink division-link"><span>{{ division.label }} <span class="clr_blue">(0)</span></span><span class="fa-solid fa-chevron-right division-chevron" aria-hidden="true"></span></span></li></ul>
    </nav>
    <div v-else id="divFacetPanel" class="facet-panel row narrowdisciplinehedertop">
        <h4 id="refineTitle">Refine</h4>
        <DisciplineFilter />
        <template v-for="group in search.primaryFacetGroups.value" :key="group.name">
            <h3 v-if="group.name !== 'Others' || !search.state.facetSelected" class="special-series-heading"><img v-if="group.icon" :src="group.icon" alt="" class="special-series-icon" />{{ group.name }}</h3>
            <FacetGroup v-for="facet in group.facets" :key="facet.AttributeTypeSk" :facet="facet" />
        </template>
        <FacetGroup v-for="facet in standardFacets" :key="facet.AttributeTypeSk" :facet="facet" />
    </div>
  </div>
</template>
